import script from "./form-textbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-textbox.vue?vue&type=script&setup=true&lang=ts"

import "./form-textbox.vue?vue&type=style&index=0&id=0b35ddfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b35ddfc"]])

export default __exports__